import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { ISelectedPassengerForCancelIds, PassengerPriceDetails } from "../../../Orchestrator/Types/Index";


export class PassengerOutboundCheckReturnJourneyAction extends BaseAction<void, {
    checked: boolean,
    passengerId: string,
    selectedPassengerForCancel: ISelectedPassengerForCancelIds[],
    allPassengerPriceAndAgeGroup: PassengerPriceDetails[],
    allPassengerPriceAndAgeGroupInBound: PassengerPriceDetails[],
    tripDisableForCancelSelection: string[]
}> {
    async run(): Promise<void | null> {
        try {
            const { checked, passengerId, selectedPassengerForCancel, allPassengerPriceAndAgeGroup, allPassengerPriceAndAgeGroupInBound, tripDisableForCancelSelection } = this.params!;
            let mainData: any = []
            if (checked) {
                const checkIsAlreadyExist = [...selectedPassengerForCancel].find((d: any) => d === passengerId)
                mainData = [...selectedPassengerForCancel]
                if (!checkIsAlreadyExist) {
                    mainData = [...selectedPassengerForCancel, passengerId]
                }

                if (!tripDisableForCancelSelection.includes(TrainTypeEnum.outbound)) {
                    updateRecoilState("selectedPassengerForCancelAtom", mainData);
                }

                if (allPassengerPriceAndAgeGroupInBound && allPassengerPriceAndAgeGroupInBound.length > 0
                    && !tripDisableForCancelSelection.includes(TrainTypeEnum.inbound)
                ) {
                    updateRecoilState("selectedPassengerForCancelInBoundAtom", mainData);
                }

            } else {
                mainData = selectedPassengerForCancel.filter((d: any) => d !== passengerId);

                if (!tripDisableForCancelSelection.includes(TrainTypeEnum.outbound)) {
                    updateRecoilState("selectedPassengerForCancelAtom", mainData);
                }
                if (allPassengerPriceAndAgeGroupInBound && allPassengerPriceAndAgeGroupInBound.length > 0
                    && !tripDisableForCancelSelection.includes(TrainTypeEnum.inbound)) {
                    updateRecoilState("selectedPassengerForCancelInBoundAtom", mainData);
                }
            }

            if (!tripDisableForCancelSelection.includes(TrainTypeEnum.outbound)) {
                const priceDetails = allPassengerPriceAndAgeGroup.filter(d => mainData.includes(d.pId));
                updatePaymentItems(priceDetails, "paymentOutBoundItemsDetailsAtom");
            }


            if (allPassengerPriceAndAgeGroupInBound && allPassengerPriceAndAgeGroupInBound.length > 0
                && !tripDisableForCancelSelection.includes(TrainTypeEnum.inbound)
            ) {
                const priceDetailsInBound = allPassengerPriceAndAgeGroupInBound.filter(d => mainData.includes(d.pId));
                updatePaymentItems(priceDetailsInBound, "paymentInboundItemsDetailsAtom");
            }


        } catch (error) {
            console.error("Error in PassengerOutboundCheck action.:", error);
        }
    }
}

const updatePaymentItems = (outBoundPassengerPriceList: any, atomKey: string) => {
    let allOutBoundInfantCount = 0
    let allOutBoundChildrenCount = 0
    let allOutBoundAdultCount = 0
    let allStudentCount = 0
    let allOutBoundSeniorCitizenCount = 0
    let allWheelchairCount = 0
    let allReducedMobilityCount = 0
    outBoundPassengerPriceList.forEach((p: any) => {
        if (p.pType === "Infant") allOutBoundInfantCount++
        if (p.pType === "Children") allOutBoundChildrenCount++
        if (p.pType === "Student") allStudentCount++
        if (p.pType === "Adult") allOutBoundAdultCount++
        if (p.pType === "Senior Citizen") allOutBoundSeniorCitizenCount++
        if (p.pType === "Wheelchair") allWheelchairCount++
        if (p.pType === "People with Reduced Mobility") allReducedMobilityCount++
    })
    const outBoundPassengerDetails = []
    if (allOutBoundAdultCount > 0) outBoundPassengerDetails.push({
        description: `${allOutBoundAdultCount} Adult`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Adult")?.pValue || 0) * allOutBoundAdultCount
    })
    if (allOutBoundChildrenCount > 0) outBoundPassengerDetails.push({
        description: `${allOutBoundChildrenCount} Children`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Children")?.pValue || 0) * allOutBoundChildrenCount
    })
    if (allOutBoundInfantCount > 0) outBoundPassengerDetails.push({
        description: `${allOutBoundInfantCount} Infant`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Infant")?.pValue || 0) * allOutBoundInfantCount
    })
    if (allOutBoundSeniorCitizenCount > 0) outBoundPassengerDetails.push({
        description: `${allOutBoundSeniorCitizenCount} Senior Citizen (UAE)`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Senior Citizen")?.pValue || 0) * allOutBoundSeniorCitizenCount
    })
    if (allStudentCount > 0) outBoundPassengerDetails.push({
        description: `${allStudentCount} Student`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Student")?.pValue || 0) * allStudentCount
    })
    if (allReducedMobilityCount > 0) outBoundPassengerDetails.push({
        description: `${allReducedMobilityCount} People with Reduced Mobility`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "People with Reduced Mobility")?.pValue || 0) * allReducedMobilityCount
    })
    if (allWheelchairCount > 0) outBoundPassengerDetails.push({
        description: `${allWheelchairCount} Wheelchair`,
        amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Wheelchair")?.pValue || 0) * allWheelchairCount
    })

    if (atomKey === "paymentOutBoundItemsDetailsAtom")
        updateRecoilState(atomKey, outBoundPassengerDetails)
    if (atomKey === "paymentInboundItemsDetailsAtom")
        updateRecoilState(atomKey, outBoundPassengerDetails)
}

export const passengerOutboundCheckReturnJourneyAction = new PassengerOutboundCheckReturnJourneyAction();